import CompanyTabs from "#src/components/companyTabs.js";
import {useContext, useEffect, useState, useMemo} from "react";
import {GetProductSettingsHandler } from "#src/helper/getProductSettingsHandler";
import { UserContext } from '#src/context/UserContext';
import { APIGetCompanyData} from '#src/api/companies/Companies';
import { IoIosCheckmarkCircle,IoIosCloseCircleOutline   } from "react-icons/io";
import tier from "#src/configs/config.json"

export const CompanyProducts = () => {

  const [company, setCompany] = useState(null);
  const { user } = useContext(UserContext);

  const filteredTier = useMemo(() => {
    return tier?.products?.filter((p) => {
      return p?.id !== "plan100";
    });
  }, [tier?.products]);


  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const companyData = await APIGetCompanyData(user?.companyId);
              companyData["permissions"] = GetProductSettingsHandler(companyData?.["products"]);
        if (!companyData) {
          throw new Error('Error: Could not load company');
        }
        setCompany(companyData);
      } catch (error) {
        console.error('Error:', error);
      }
    };

    if (!company) {
      fetchCompanyData();
    }
  }, [company, user]);


  return (
      <div className="mx-auto max-w-7xl w-full bg-gray-100 px-4">
        <h2 className="text-xl my-8 flex  ml-4 font-semibold  leading-7 text-gray-900 sm:truncate sm:text-2xl sm:tracking-tight">
          Account
        </h2>
        <CompanyTabs page={"Lizenzen"}/>
        <div className=" mb-12 w-full  gap-x-8">
          <div className="isolate mx-auto  ">
              <section class="text-gray-700 body-font overflow-hidden ">
                  <div class="container  pb-24  flex w-full flex-wrap">
                      <div class="lg:w-1/4 mt-48 hidden lg:block">
                          <div class="mt-px border-t border-gray-400 bg-white border-b border-l rounded-tl-lg rounded-bl-lg overflow-hidden">
                                {filteredTier?.[0]?.components.map((c) => {
                                    return (
                                        <div>
                                            <p className="bg-gray-100 text-gray-900 text-sm mt-4 font-bold h-12 text-center px-4 flex items-center justify-start">{c?.name}</p>
                                            {c?.features?.map((f) => {
                                                return (
                                                    <p className="bg-gray-100 text-gray-900 h-12 text-sm text-center px-4 flex items-center justify-start -mt-px">{f?.name}</p>
                                                );
                                            })}
                                        </div>
                                    );
                                })}

                          </div>
                      </div>


                      <div className="flex lg:w-3/4 w-full flex-wrap lg:border border-gray-400 bg-white rounded-lg">

                          {filteredTier?.map((p) => {
                              return (
                                  <div className="lg:w-1/4 lg:mt-px w-full mb-10 lg:mb-0 border-2 border-gray-300 lg:border-none rounded-lg lg:rounded-none">
                                      <div className="px-2 text-center h-48 flex flex-col items-center justify-center">
                                          <h3 className="tracking-widest">{(company?.products?.includes(p?.id) === true) && (<div className={" -mt-6"}>Gebucht</div>) }</h3>
                                          <h2 className="text-5xl text-gray-900 font-medium leading-none mb-4 mt-2">{p?.name}</h2>
                                          <span className="text-sm text-gray-600">{p?.price}</span>
                                      </div>
                                      {p?.components?.map((c) => {
                                          return (
                                              <div>
                                              <p className="text-gray-600 text-center h-12 flex items-center  border-t border-gray-300 justify-center"><div className={"font-bold lg:hidden"}>{c?.name}</div></p>
                                                  {c?.features?.map((f) => {
                                                      var v = f?.value;
                                                      if(f?.value === true) {
                                                          v = (<IoIosCheckmarkCircle className={"text-gray-900 size-6"}/>);
                                                      } else if(f?.value === false) {
                                                          v = (<IoIosCloseCircleOutline  className={"text-gray-500 size-6"}/>);
                                                      }


                                                      return (
                                                          <p className="bg-gray-100 text-gray-600 h-12 text-center px-2 flex items-center justify-center flex "><span className={"mr-2 lg:hidden"}>{f?.name}:</span>{v}</p>
                                                      );
                                                  })}
                                              </div>
                                          );
                                      })}

                                      <div className="border-t border-gray-300 p-6 text-center rounded-bl-lg">
                                          {(company?.products?.includes(p?.id) === true) ? (
                                              <button className="flex items-center mt-auto text-white bg-indigo-500 border-0 py-2 px-4 w-full focus:outline-none hover:bg-indigo-600 rounded">Gebucht</button>
                                          ) : (
                                              <div>
                                                  {(p?.id !== "xs") && (
                                                      <a href={"https://www.xplanung24.de/lizenz-upgraden/"} target={"_blank"} className="flex items-center mt-auto text-gray-900 bg-gray-400 border-0 py-2 px-4 w-full focus:outline-none hover:bg-indigo-600 rounded">Wechseln
                                                          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="w-4 h-4 ml-auto" viewBox="0 0 24 24">
                                                              <path d="M5 12h14M12 5l7 7-7 7"></path>
                                                          </svg>
                                                      </a>
                                                  )}

                                              </div>
                                          )}
                                      </div>
                                  </div>
                              );
                          })}

                      </div>
                  </div>
              </section>
          </div>
        </div>
      </div>
  )
}
